<template>
  <div class="my-addresses-container responsive-p">
    <NavigationBar :items="navItems" />
    <div class="top-header-wrapper">
      <button @click="back" v-if="!isDesktop">
        <img src="@/assets/icons/primary-back.svg" alt="back">
      </button>
      <p class="title">{{ t('addAddresses.title') }}</p>
    </div>
    <div class="content-wrapper">
      <!-- <div class="group-button-wrapper">
        <ButtonSelector :label="t('addAddresses.inCountry')" :value="true" v-model="inCountry" />
        <ButtonSelector :label="t('addAddresses.abroad')" :value="false" v-model="inCountry"/>
      </div> -->
     <div v-if="inCountry" class="form-wrapper">
      <TextInput v-model="receiveName" :label="t('addAddresses.form.receiveName')" required />
      <TextInput v-model="phone" :label="t('addAddresses.form.phone')" required />
      <DropdownInput
        :label="t('addAddresses.form.address')"
        :items="addresses"
        v-model="address"
        required
      />
      <TextInput v-model="addressNo" :label="t('addAddresses.form.addressNo')" required />
      <DropdownInput
        :label="t('addAddresses.form.province')"
        :items="provinceChoices"
        v-model="province"
        required
      />
      <DropdownInput
        :label="t('addAddresses.form.district')"
        :items="districtChoices"
        v-model="district"
        required
      />
      <DropdownInput
        :label="t('addAddresses.form.subDistrict')"
        :items="subDistrictChoices"
        v-model="subDistrict"
        required
      />
      <TextInput v-model="zipCode" :label="t('addAddresses.form.zipCode')" required />
      <CheckBox v-model="isDefault" :label="t('addAddresses.form.setMainAddress')" class="mb-2" />
      <MButton fullWidth @click="add">{{ t('addAddresses.form.save') }}</MButton>
     </div>
     <!-- <div v-else-if="!inCountry" class="form-wrapper">
       <TextInput v-model="receiveName" :label="t('addAddresses.form.receiveName')" required />
       <TextInput v-model="phone" :label="t('addAddresses.form.phone')" required />
       <TextInput v-model="address" :label="t('addAddresses.form.address')" required />
       <TextInput v-model="addressNo" :label="t('addAddresses.form.addressNo')" required />
       <TextInput v-model="province" :label="t('addAddresses.form.province')" required />
       <TextInput v-model="district" :label="t('addAddresses.form.district')" required />
       <TextInput v-model="subDistrict" :label="t('addAddresses.form.subDistrict')" required />
       <TextInput v-model="zipCode" :label="t('addAddresses.form.zipCode')" required />
       <CheckBox v-model="isDefault" :label="t('addAddresses.form.setMainAddress')" class="mb-2" />
       <MButton fullWidth @click="add">{{ t('addAddresses.form.save') }}</MButton>
     </div> -->
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useScreenSize } from '@/utils/isDesktop'

import TextInput from '@/components/Form/TextInput'
import MButton from '@/components/Form/MButton'
import DropdownInput from '@/components/Form/DropdownInput'
import CheckBox from '@/components/Form/CheckBox'
import NavigationBar from '@/components/NavigationBar'

export default {
  name: 'MyAddressView',
  components: {
    TextInput,
    MButton,
    DropdownInput,
    CheckBox,
    NavigationBar,
},
  setup() {
    /** context */
    const store = useStore()
    const router = useRouter()
    const { t, locale } = useI18n()
    const { isDesktop } = useScreenSize()

    /** reactive */
    const inCountry = ref(true) 
    const receiveName = ref('')
    const phone = ref('')
    const address = ref({ value: t('addAddresses.form.home'), label:  t('addAddresses.form.home') })
    const addressNo = ref('')
    const province = ref({})
    const district = ref({})
    const subDistrict = ref({})
    const zipCode = ref('')
    const isDefault = ref(false)
    const addresses = [
      { value: t('addAddresses.form.home'), label:  t('addAddresses.form.home') },
      { value: t('addAddresses.form.work'), label:  t('addAddresses.form.work') },
    ]
    const navItems = computed(() => [
      {
        name: t('menu.home'),
        path: '/'
      },
      {
        name: t('menu.profile'),
        path: '/my-profile'
      },
      {
        name: t('profileMenu.address'),
        path: '/my-addresses'
      },
      {
        name: t('addAddresses.title'),
      }
    ])
    const getUser = computed(() => store.getters['user/getUser'])

    const provinceChoices = computed(() => store.state.user.provinces.map(i => ({ ...i, value: i.province_code, label: i.province_name })))
    const districtChoices = computed(() => store.state.user.districts.map(i => ({ ...i, value: i.district_code, label: i.district_name })))
    const subDistrictChoices = computed(() => store.state.user.subDistricts.map(i => ({ ...i, value: i.sub_district_code, label: i.sub_district_name })))
    /** method */
    const back = () => router.back()
    const showWarning = (message) => {
      store.commit('snackBar/SET_DATA', { message, color: 'warning' })
    }
    const getRequiredMessage = (label) => (
      locale.value === 'th' ? `กรุณากรอก${label}` : `Please fill ${label}`
    )
    const add = async () => {
      const requiredFields = [
        [receiveName.value?.trim(), t('addAddresses.form.receiveName')],
        [phone.value?.trim(), t('addAddresses.form.phone')],
        [address.value?.label, t('addAddresses.form.address')],
        [addressNo.value?.trim(), t('addAddresses.form.addressNo')],
        [province.value?.label, t('addAddresses.form.province')],
        [district.value?.label, t('addAddresses.form.district')],
        [subDistrict.value?.label, t('addAddresses.form.subDistrict')],
        [String(zipCode.value || '').trim(), t('addAddresses.form.zipCode')],
      ]

      const missingField = requiredFields.find(([value]) => !value)
      if (missingField) {
        return showWarning(getRequiredMessage(missingField[1]))
      }

      if (!/^(0[689])[0-9]{8}$/.test(String(phone.value).trim())) {
        return showWarning(
          locale.value === 'th'
            ? 'กรุณากรอกเบอร์โทรศัพท์ของท่านให้ถูกต้อง'
            : 'Please enter a valid phone number'
        )
      }

      const body = {
        name: receiveName.value?.trim(),
        phone: String(phone.value).trim(),
        address_name: address.value?.label,
        address_number: addressNo.value?.trim(),
        address_province: province.value?.label,
        address_district: district.value?.label,
        address_sub_district: subDistrict.value?.label,
        address_postcode: String(zipCode.value).trim(),
        is_primary: isDefault.value,
        is_in_country: inCountry.value,
      }

      if (!getUser.value) {
        const guestAddress = {
          ...body,
          id: Date.now(),
          isSelected: true,
          full_address: [
            body.address_number,
            body.address_sub_district,
            body.address_district,
            body.address_province,
            body.address_postcode,
          ].filter(Boolean).join(' '),
        }
        localStorage.setItem('userAddress', JSON.stringify([guestAddress]))
        store.commit('user/SET_ADDRESSES', [guestAddress])
        router.replace('/my-cart/checkout')
        return
      }

      await store.dispatch('user/fetchAddNewAddress', body)
    }

    /** mounted */
    onMounted(() => {
      store.dispatch('user/fetchGetProvince')
    })
    
    watch(() => province.value, (newValue) => {
      if (newValue) {
        store.dispatch('user/fetchGetDistrict', newValue.value)
        district.value = {}
        subDistrict.value = {}
        zipCode.value = ''
      }
    })

    watch(() => district.value, (newValue) => {
      if (newValue) {
        store.dispatch('user/fetchGetSubDistrict', newValue.value)
        subDistrict.value = {}
        zipCode.value = ''
      }
    })

    watch(() => subDistrict.value, (newValue) => {
      if (newValue) {
        zipCode.value = newValue.postcode
      }
    })

    return {
      t,
      add,
      back,
      inCountry,
      receiveName,
      phone,
      address,
      addressNo,
      province,
      district,
      subDistrict,
      zipCode,
      isDefault,
      provinceChoices,
      districtChoices,
      subDistrictChoices,
      addresses,
      getUser,
      isDesktop,
      navItems,
    }
  }
}
</script>

<style lang="scss" scoped>

.my-addresses-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  // No top padding: the header is sticky/in-flow and reserves its own space.
  // (A prior padding-top here was silently cancelled by `.responsive-p`'s
  //  `padding-top: 0 !important`, which caused the header to overlap the form.)
  @media screen and (min-width: 780px) {
    padding-bottom: 0;
    height: calc(100% - 74px);
    margin-top: 24px;
  }
}

.top-header-wrapper {
  // Sticky + in-flow so it always reserves its own height (no magic padding to
  // match, and immune to `.responsive-p`'s `padding-top: 0 !important`).
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #D6E2EF;
  background-color: var(--white-color);
  > button {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    font-size: 20px;
    color: var(--secondary-color);
    outline: none;
    background-color: transparent;
    border: 0;
    padding: 8px;
  }
  @media screen and (min-width: 780px) {
    position: relative;
    border-bottom: 0;
  }
}

.group-button-wrapper {
  display: flex;
  gap: 24px;
  > * {
    flex: 1;
  }
  margin-bottom: 24px;
}

.title {
  font-size: 24px;
  font-weight: bold;
}

.content-wrapper {
  padding: 16px;
}
</style>
